Object.defineProperty(exports, "__esModule", { value: true });
var AsIterable = /** @class */ (function () {
    function AsIterable() {
    }
    /**
     * Returns an iterable representation of the sequence.
     *
     * @returns {Iterable<T>}
     */
    AsIterable.prototype.asIterable = function () {
        var _a;
        var iterator = this.iterator;
        return _a = {},
            _a[Symbol.iterator] = function () {
                return iterator;
            },
            _a;
    };
    return AsIterable;
}());
exports.AsIterable = AsIterable;
//# sourceMappingURL=asIterable.js.map